import { Stack, Divider, Card, Typography } from '@mui/material';
import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Product } from '@subflow/api-client';

import { Interval } from 'apps/frontend/sections/@dashboard/store/SubscriptionNewForm';
import { fCurrency } from '../../../../utils/formatNumber';

const RootStyle = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3, 0),
  },
  [theme.breakpoints.up(1368)]: {
    padding: theme.spacing(5, 8),
  },
}));

type Props = {
  product: Product;
};

export default function SubscriptionCheckoutButton({ product }: Props) {
  // @ts-expect-error: interval exists on recurring
  const interval = product?.prices?.[0]?.recurring?.interval;
  // @ts-expect-error: interval exists on recurring
  const intervalCount = product?.prices?.[0]?.recurring?.intervalCount;

  const intervalText =
    interval === Interval.Monthly && intervalCount === 3 ? 'quarter' : interval;

  const price = `${fCurrency((product?.prices?.[0]?.unitAmount || 0) / 100)}${
    interval ? ` per ${intervalText}` : ''
  }`;

  return (
    <RootStyle>
      <Card>
        <Stack spacing={3} mx={3} pb={3} pt={3}>
          <Typography variant="h5">{price}</Typography>

          <Divider sx={{ borderStyle: 'solid' }} />

          <MuiButton variant="contained" sx={{ mt: 2 }} href="checkout">
            Add Payment Details
          </MuiButton>
        </Stack>
      </Card>
    </RootStyle>
  );
}
